import * as React from 'react';
import { UserIcon } from 'lucide-react';
import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';
import { cn } from 'lib/utils';

export const UserCircleICon = () => {
  return (
    <div className={'bg-gray-600 text-white rounded-full w-6 h-6 flex items-center justify-center'}>
      <UserIcon className={'w-4 h-4'} />
    </div>
  );
};

export const TimelineSkeletonCard = () => {
  return (
    <Card className={'shadow-none w-full max-w-[460px]'}>
      <CardContent className={'pt-6'}>
        <div className={'flex items-center gap-2 mb-4'}>
          <UserCircleICon />
          <Skeleton className={'w-40 h-[14px] mt-2'} />
        </div>
        <Skeleton className={'w-80 h-3'} />
        <Skeleton className={'w-40 h-3 mt-4'} />
      </CardContent>
    </Card>
  );
};

type TimelineContainerProps = React.ComponentProps<'div'> & {
  timelineTitle: React.ReactNode;
  timelineIcon: React.ReactNode;
}

export const TimelineContainer = ({
                             timelineTitle,
                             timelineIcon,
                             className,
                             children,
                             ...props
                           }: TimelineContainerProps) => {
  return (
    <div {...props} className={cn('flex flex-col gap-6', className)}>
      <div className={'flex items-center gap-2 text-gray-600 pl-6'}>
        {timelineIcon}
        <span className={'font-GilroyBold text-[18px]'}>{timelineTitle}</span>
      </div>
      {children}
    </div>
  );
};